import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environment';
import { CustomerSettings } from '@sb-tools/typescript/models/customer-settings.model';
import { InboxElementVisibilitySettings } from '@sb-tools/typescript/models/inbox-elements-visibility.model';

@Injectable({
    providedIn: 'root',
})
export class CustomerConfigurationService {
    constructor(private httpClient: HttpClient) {}

    getCustomerInstance(): Observable<CustomerSettings> {
        return this.httpClient.get<CustomerSettings>(environment.apiMasterUrl + 'authorized/customerByCommunity/');
    }

    getAdminCustomerInstance(): Observable<CustomerSettings> {
        return this.httpClient.get<CustomerSettings>(environment.apiMasterUrl + 'authorized/CustomerForSettings');
    }

    updateCustomerInstance(configurationModel: Partial<CustomerSettings>): Observable<CustomerSettings> {
        return this.httpClient.patch<CustomerSettings>(
            environment.apiMasterUrl + 'admin/customerByCommunity/',
            configurationModel,
        );
    }

    getInboxElementVisibilitySettings(): Observable<InboxElementVisibilitySettings> {
        return this.httpClient.get<InboxElementVisibilitySettings>(
            environment.apiMasterUrl + 'Admin/Customer/InboxElementVisibilitySettings',
        );
    }

    updateInboxElementVisibilitySettings(
        settings: Partial<InboxElementVisibilitySettings>,
    ): Observable<InboxElementVisibilitySettings> {
        return this.httpClient.patch<InboxElementVisibilitySettings>(
            environment.apiMasterUrl + 'Admin/Customer/InboxElementVisibilitySettings',
            settings,
        );
    }
}
